module.exports = __webpack_public_path__ + "static/media/app icon (10).11bd77dc.png";